import * as React from 'react'
import { TextWithHorizontalLine } from 'uiComponents/pageElements'
import { FORM_SECTION } from 'capacity/copy'
import './capacitySection.scss'

interface CapacitySectionShellProps {
    capacities: React.ReactNode
    timeSlots: React.ReactNode
    timeSlotsControl?: React.ReactNode
}

export function CapacitySectionShell({ capacities, timeSlots, timeSlotsControl }: CapacitySectionShellProps) {
    return (
        <>
            <TextWithHorizontalLine
                style={{ marginTop: '0.8rem', marginBottom: '1rem' }}
                text={FORM_SECTION.heading.toUpperCase()}
                alignment="left"
            />
            <div className="capacity-section">
                <div className="capacity-section-part">
                    <h4 className="capacity-section-heading">{FORM_SECTION.capacities}</h4>
                    <div className="capacity-section-list">{capacities}</div>
                </div>
                <div className="capacity-section-part">
                    <h4 className="capacity-section-heading">{FORM_SECTION.timeSlots}</h4>
                    {timeSlotsControl}
                    {timeSlots}
                </div>
            </div>
        </>
    )
}
